import React from 'react';

const DebitoEmConta = () => {
    return (<h1>Debito em conta</h1>);
};

export default DebitoEmConta;